import { selectZillDevelopmentThemeNode } from '@newStore/documentUI/transformContent/zillContentNodeSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { attachedContentComponent } from '@nodeTypeConfig/helpers/editComponents/attachedContent';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { imageComponentBase } from '@nodeTypeConfig/helpers/editComponents/imageComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const CURRICULUM_ZILL_DEVELOPMENT_THEME: BuildingBlockNodeConfig = {
  nodeSelector: selectZillDevelopmentThemeNode,
  information: {
    single: 'Thema',
    plural: "Thema's",
  },
  createDefaults: {
    attachments: [
      {
        type: 'CONTENT',
        name: 'content.html',
        contentType: 'text/html',
      },
    ],
  },
  buildingBlocks: [{ type: NodeType.CURRICULUM_ZILL_GENERIC_GOAL }],
  edit: [
    {
      ...identifierComponent,
      width: 2,
    },
    {
      ...titleComponent,
      width: 10,
    },
    descriptionComponent,
    {
      ...attachedContentComponent,
      label: 'Lees meer',
    },
    {
      ...imageComponentBase,
      label: 'Omslagfoto',
      options: {
        type: 'COVER_IMAGE',
        fields: [],
      },
    },
    {
      ...imageComponentBase,
      label: 'Miniatuur',
      options: {
        type: 'THUMBNAIL',
      },
    },
  ],
  documentViewIdentifier: 'pi',
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default CURRICULUM_ZILL_DEVELOPMENT_THEME;
